export enum AvailableGlobalPermissions {
  ACCOUNT = 'Account',
  PROJECT = 'Project',
  POSITION = 'Position',
  ASSIGNMENT = 'Assignment',
  USER = 'User',
  AUTH_USER = 'AuthUser',
  ACCESS_GROUP = 'AG',
  PERMISSION = 'Permission',
  DEMAND = 'Demand',
  COUNTRIES = 'Countries',
  SENSITIVE_USER_DATA = 'SensitiveUserData',
  CALENDAR = 'Calendar',
}

export enum AvailablePermissionsValue {
  READ = 'READ',
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  ARCHIVE = 'ARCHIVE',
  DELETE = 'DELETE',
  MAP = 'MAPPING',
}

export enum AvailableFlagPermissions {
  TIMESHEET_APPROVE = 'Timesheet.Approve',
  TIMESHEET_VIEW = 'Timesheet.View',
  TIMESHEET_PERIOD_REOPEN = 'TimesheetPeriod.Reopen',
  TIMESHEET_EDIT = 'Timesheet.Edit',
  TIMESHEET_PERIOD_CLOSE = 'TimesheetPeriod.Close',
  TIMESHEET_PERIOD_VIEW = 'TimesheetPeriod.View',
}

export enum AvailablePermissionFlagsValue {
  ENABLE = 'ENABLE',
  DISABLE = 'DISABLE',
}

interface IGlobalPermission {
  type: 'global';
  global: AvailableGlobalPermissions | AvailableFlagPermissions;
  value: AvailablePermissionsValue | AvailablePermissionFlagsValue;
}

interface ILocalPermission extends Omit<IGlobalPermission, 'type'> {
  type: 'local';
  local: string;
}

interface IParentPermission extends Omit<IGlobalPermission, 'type'> {
  type: 'subGlobal';
  parent: string;
  subGlobal: AvailableGlobalPermissions;
}

interface ISubFlagGlobalPermission extends Omit<IGlobalPermission, 'type' | 'global'> {
  type: 'flagLocal';
  global: AvailableGlobalPermissions;
  subFlagGlobal: AvailableFlagPermissions;
  parent: string;
}

type RequiredPermission = IGlobalPermission | ILocalPermission | IParentPermission | ISubFlagGlobalPermission;

// [[ { global: first, value: READ }, { global: other, value: READ } ]] - means THE FIRST OR SECOND
// [[{ global: first, value: READ } ], [ { global: other, value: READ } ]] - means THE FIRST AND SECOND
export type RequiredPermissions = RequiredPermission[][];
